import React from 'react';
import PropTypes from 'prop-types';
import HorizontalStick from './HorizontalStick';

import { percentOfNumber } from '../../utils';

const HorizontalBar = ({ data, tag, maxValue }) => {
  let id = 0;

  return (
    <div className="horizontal-bar">
      <span className="horizontal-bar__key">{tag}</span>
      <div style={{ width: '100%', height: '100%' }}>
        {
          data.map((value, index) =>
            <HorizontalStick 
              key={`${tag}-${id++}`} 
              width={percentOfNumber(value, maxValue) || 2} 
              value={value === "Infinity" || value === null ? 0 : value} 
              isEven={index % 2 === 0}
            />
          )
        }
      </div>
    </div>
  );
}

HorizontalBar.propTypes = {
  data: PropTypes.object,
  maxValue: PropTypes.number,
  tag: PropTypes.string,
}


HorizontalBar.defaultProps = {
  data: {},
  maxValue: 0,
  tag: '',
}

export default HorizontalBar;
